// src/admin/pages/AdminDashboardPage.tsx
import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { useQuery } from "@apollo/client";
import { ADMIN_DASHBOARD_QUERY } from "../../graphql/dashboard";
import AdminLoading from "../Components/AdminLoading";
import Alert from "@mui/material/Alert";

const AdminDashboardPage: React.FC = () => {
  const { data, loading, error } = useQuery(ADMIN_DASHBOARD_QUERY);

  return (
    <Box>
      <Typography variant="h5" mb={3}>
        Dashboard
      </Typography>

      <AdminLoading open={loading} />

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Failed to load dashboard: {error.message}
        </Alert>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle2" color="text.secondary">
              Total Products
            </Typography>
            <Typography variant="h6">{data?.productsCount ?? "-"}</Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle2" color="text.secondary">
              Campaigns
            </Typography>
            <Typography variant="h6">{data?.campaignsCount ?? "-"}</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboardPage;
